import React from 'react'
import {Row,Col} from 'react-bootstrap'
import { useSelector} from "react-redux"
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/pl'

import KonkursInfo from '../Konkursy/konkurs_informacja'

const DataKonkurs = (props) => {
    const id        = useSelector((magazyn) => magazyn.opcje)
    dayjs.locale('pl')
    dayjs.extend(LocalizedFormat)   
    const powrot = () => {
        sessionStorage.clear()
        props.funkcjaWidok('K')
   } 
const dataK = dayjs(id.czasTestu*1000).locale('pl').format('LLLL')
    return <div>
        <KonkursInfo/>        
         <Row>
            <Col xs={12}><h2 className='napis_left'>Uwaga konkurs dla uczestnika będzie dostępny :</h2></Col>
         </Row>
         <Row className='wynik'>
            <Col xs={12}>W {dataK}</Col>
         </Row>
         <Row>   
            <Col xs={6}>
            <button className="btn btn-primary btn-lg btn-block mt-2 przycisk"
                        onClick={powrot}>Powrót</button>
            </Col><Col xs={6}></Col>
        </Row>
    </div>
}

export default DataKonkurs